import {
  GET_COUNTRY_BEGIN,
  GET_COUNTRY_SUCCESS,
  GET_COUNTRY_ERROR,
  GET_STATE_BEGIN,
  GET_STATE_SUCCESS,
  GET_STATE_ERROR,
  GET_CITY_BEGIN,
  GET_CITY_SUCCESS,
  GET_CITY_ERROR,
} from "../utils/action";

const Basic_reducer = (state, action) => {
  switch (action.type) {
    case GET_COUNTRY_BEGIN:
      return { ...state, get_country_loading: true };

    case GET_COUNTRY_SUCCESS:
      return {
        ...state,
        get_country_loading: false,
        get_country_data: action.payload,
      };

    case GET_COUNTRY_ERROR:
      return { ...state, get_country_loading: false };

    case GET_STATE_BEGIN:
      return { ...state, get_state_loading: true };

    case GET_STATE_SUCCESS:
      return {
        ...state,
        get_state_loading: false,
        get_state_data: action.payload,
      };

    case GET_STATE_ERROR:
      return { ...state, get_state_loading: false };

    case GET_CITY_BEGIN:
      return { ...state, get_city_loading: true };

    case GET_CITY_SUCCESS:
      return {
        ...state,
        get_city_loading: false,
        get_city_data: action.payload,
      };

    case GET_CITY_ERROR:
      return { ...state, get_city_loading: false };

    default:
      return state;
  }
};

export default Basic_reducer;
